import * as React from 'react';
export const TLSvg = React.forwardRef(function TLSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#E25950',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M0 10.038V1.964c.017-.52.429-.8.935-.604L13 6 .935 10.64c-.506.195-.918-.074-.934-.602Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M.664 11.488A2.01 2.01 0 0 1 0 9.99V2.01C0 1.415.257.88.665.512.708.535.75.564.796.597L8 6 .796 11.403a1.03 1.03 0 0 1-.132.085Z',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 3,
        cy: 6,
        r: 1,
        fill: '#F7FAFC',
      }),
    ),
  );
});
TLSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var TL = {
  category: 'flag',
  colorable: false,
  name: 'TL',
  svg: TLSvg,
};
